import { render, staticRenderFns } from "./GameTestingDino.vue?vue&type=template&id=7c7996ec&"
import script from "./GameTestingDino.vue?vue&type=script&lang=js&"
export * from "./GameTestingDino.vue?vue&type=script&lang=js&"
import style0 from "./GameTestingDino.vue?vue&type=style&index=0&id=7c7996ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports